<div class="file-upload-container">
  <!-- Current file display -->
  <div *ngIf="(currentFile || hasSelectedFile()) && !isUploading" class="current-file">
    <div class="file-info">
      <!-- Image preview -->
      <div *ngIf="getFilePreviewUrl()" class="file-preview">
        <img [src]="getFilePreviewUrl()" [alt]="getFileName()" class="preview-image">
      </div>
      <!-- File icon for non-images -->
      <mat-icon *ngIf="!getFilePreviewUrl()" class="file-icon">description</mat-icon>
      
      <div class="file-details">
        <div class="file-name">{{ getFileName() }}</div>
        <div class="file-size" *ngIf="getFileSize()">{{ getFileSize() }}</div>
      </div>
      <button 
        type="button" 
        class="dl-btn dl-btn--danger-ghost dl-btn--icon dl-btn--sm" 
        (click)="onRemoveFile()" 
        [disabled]="disabled"
        matTooltip="Remove file">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Upload area -->
  <div 
    *ngIf="(!currentFile && !hasSelectedFile()) || isUploading"
    class="upload-area"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    [ngClass]="{ 
      'drag-over': isDragOver, 
      'disabled': disabled,
      'uploading': isUploading 
    }"
    (click)="!disabled && fileInput.click()">
    
    <!-- Uploading state -->
    <div *ngIf="isUploading" class="uploading-state">
      <mat-icon class="upload-spin">hourglass_empty</mat-icon>
      <p>Uploading... {{ uploadProgressValue }}%</p>
      <div class="progress-bar">
        <div class="progress-fill" [style.width.%]="uploadProgressValue"></div>
      </div>
    </div>

    <!-- Default state -->
    <div *ngIf="!isUploading" class="upload-content">
      <mat-icon class="upload-icon">cloud_upload</mat-icon>
      <p class="upload-text">{{ placeholder }}</p>
      <!-- Drag and drop does not exist on a touch screen, and until this button
           the only affordance was a click on the div. Visual only: the click
           handler on the drop zone above already opens the picker. -->
      <span class="dl-btn dl-btn--sm upload-choose">
        <mat-icon>folder_open</mat-icon>
        Choose a file
      </span>
      <p class="upload-hint">Maximum file size: {{ formatFileSize(maxSize) }}</p>
    </div>

    <!-- Hidden file input -->
    <input 
      #fileInput
      type="file" 
      [accept]="acceptedTypes"
      (change)="onFileSelected($event)"
      [disabled]="disabled"
      hidden>
  </div>

  <!-- Error message -->
  <div *ngIf="error" class="dl-banner dl-banner--error">
    <mat-icon>error</mat-icon>
    <span>{{ error }}</span>
  </div>
</div>
